module.exports = __webpack_public_path__ + "VIPV13.png?15062cc49bfcbc7e94cd4944b326c18e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV13.png
// module id = 107
// module chunks = 0